import type { ReefState } from "./coral-chorus-core";

export function coralHistoryStep(state: ReefState, step: number): number {
  return Number.isFinite(step) ? Math.max(0, Math.min(state.pieces.length, Math.floor(step))) : state.pieces.length;
}

// A view of a placement prefix, never a replacement for the live room or saved reef.
// Reusing the same seed and pieces also reproduces fish growth and neighboring highlights.
export function coralHistoryScene(state: ReefState, step: number): ReefState {
  const count = coralHistoryStep(state, step);
  return count === state.pieces.length ? state : { ...state, pieces: state.pieces.slice(0, count), admire: true };
}
